import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";

export default function PublicHeader() {
  const { user } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const close = () => setMobileOpen(false);

  return (
    <header
      className="sticky top-0 z-40 bg-white/75 backdrop-blur-xl border-b border-zinc-200"
      data-testid="public-header"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <div className="w-7 h-7 klein-bg rounded-sm flex items-center justify-center">
            <span className="font-display text-white font-bold text-sm">F</span>
          </div>
          <span className="font-display font-semibold tracking-tight text-lg">FlowMind</span>
          <span className="overline mt-1">AI</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <NavLink to="/#features" className="text-zinc-700 hover:text-black transition-colors" data-testid="nav-features">
            Fonctionnalités
          </NavLink>
          <NavLink to="/#pricing" className="text-zinc-700 hover:text-black transition-colors" data-testid="nav-pricing">
            Tarifs
          </NavLink>
          <NavLink to="/demo" className="text-zinc-700 hover:text-black transition-colors" data-testid="nav-demo">
            Démo interactive
          </NavLink>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Link to="/app/dashboard">
              <Button className="rounded-sm bg-black text-white hover:bg-zinc-800" data-testid="header-dashboard-btn">
                Tableau de bord
              </Button>
            </Link>
          ) : (
            <>
              <Link to="/login" className="text-sm text-zinc-700 hover:text-black" data-testid="header-login-link">
                Se connecter
              </Link>
              <Link to="/signup">
                <Button className="rounded-sm bg-black text-white hover:bg-zinc-800" data-testid="header-signup-btn">
                  Essai gratuit
                </Button>
              </Link>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-sm hover:bg-zinc-100 text-black"
          aria-label="Ouvrir le menu"
          data-testid="mobile-menu-toggle"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden border-t border-zinc-200 bg-white" data-testid="mobile-menu-drawer">
          <nav className="flex flex-col p-4 gap-2">
            <NavLink to="/#features" onClick={close} className="px-3 py-3 hover:bg-zinc-50 rounded-sm text-zinc-700" data-testid="mobile-nav-features">
              Fonctionnalités
            </NavLink>
            <NavLink to="/#pricing" onClick={close} className="px-3 py-3 hover:bg-zinc-50 rounded-sm text-zinc-700" data-testid="mobile-nav-pricing">
              Tarifs
            </NavLink>
            <NavLink to="/demo" onClick={close} className="px-3 py-3 hover:bg-zinc-50 rounded-sm text-zinc-700" data-testid="mobile-nav-demo">
              Démo interactive
            </NavLink>
            <div className="border-t border-zinc-100 mt-2 pt-3 flex flex-col gap-2">
              {user ? (
                <Link to="/app/dashboard" onClick={close}>
                  <Button className="w-full rounded-sm bg-black text-white hover:bg-zinc-800" data-testid="mobile-dashboard-btn">
                    Tableau de bord
                  </Button>
                </Link>
              ) : (
                <>
                  <Link to="/login" onClick={close} className="px-3 py-3 text-zinc-700 hover:bg-zinc-50 rounded-sm" data-testid="mobile-login-link">
                    Se connecter
                  </Link>
                  <Link to="/signup" onClick={close}>
                    <Button className="w-full rounded-sm bg-black text-white hover:bg-zinc-800" data-testid="mobile-signup-btn">
                      Essai gratuit
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
